// extracted by mini-css-extract-plugin
export var grid = "_2c-0";
export var span1 = "_2c-2";
export var span10 = "_2c-b";
export var span10L = "_2c-z";
export var span10M = "_2c-n";
export var span10Xl = "_2c-1b";
export var span11 = "_2c-c";
export var span11L = "_2c-10";
export var span11M = "_2c-o";
export var span11Xl = "_2c-1c";
export var span12 = "_2c-d";
export var span12L = "_2c-11";
export var span12M = "_2c-p";
export var span12Xl = "_2c-1d";
export var span1L = "_2c-q";
export var span1M = "_2c-e";
export var span1Xl = "_2c-12";
export var span2 = "_2c-3";
export var span2L = "_2c-r";
export var span2M = "_2c-f";
export var span2Xl = "_2c-13";
export var span3 = "_2c-4";
export var span3L = "_2c-s";
export var span3M = "_2c-g";
export var span3Xl = "_2c-14";
export var span4 = "_2c-5";
export var span4L = "_2c-t";
export var span4M = "_2c-h";
export var span4Xl = "_2c-15";
export var span5 = "_2c-6";
export var span5L = "_2c-u";
export var span5M = "_2c-i";
export var span5Xl = "_2c-16";
export var span6 = "_2c-7";
export var span6L = "_2c-v";
export var span6M = "_2c-j";
export var span6Xl = "_2c-17";
export var span7 = "_2c-8";
export var span7L = "_2c-w";
export var span7M = "_2c-k";
export var span7Xl = "_2c-18";
export var span8 = "_2c-9";
export var span8L = "_2c-x";
export var span8M = "_2c-l";
export var span8Xl = "_2c-19";
export var span9 = "_2c-a";
export var span9L = "_2c-y";
export var span9M = "_2c-m";
export var span9Xl = "_2c-1a";
export var stretch = "_2c-1";